module.exports = __webpack_public_path__ + "img/tcndxq_img1-6.6de2ebae.png";